import dio, { DioType, DioContext } from 'utils/dio/init';

export default {
  googleSingInClick() {
    dio.track(
      'google_sign_in_click',
      DioType.CLICK,
      {},
      DioContext.PORTER_LOGIN_PAGE
    );
  },
  googleSignInCompleted() {
    dio.track(
      'google_sign_in_completed',
      DioType.PAGEVIEW,
      {},
      DioContext.PORTER_LOGIN_PAGE
    );
  },
};
